import { Button, Flex, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useForgetPassword } from '../../../api/hooks/useUserQuery';
import { useNotificationContext } from '../../../contexts/NotificationContext';
import { getServerErrorMsg } from '../../../helpers/errorHandler';
import ForgetPasswordHeader from './ForgetPasswordHeader';
import { SignInStageEnum } from '../../../enums/SignInStage';
import { useOTPContext } from '../../../contexts/OtpContext';
import { customizeRequiredMark } from '../../../helpers/formHelper';
import { ENVIRONMENT_CONFIG } from '../../../constants/environmentConfig';

interface ActivateUserProps {
  onChangeStage: Function;
}

const ForgetPassword = ({ onChangeStage }: ActivateUserProps) => {
  const { t } = useTranslation(['signIn']);
  const forgetPassword = useForgetPassword();
  const [forgetPasswordForm] = Form.useForm();
  const { errorNotification } = useNotificationContext();
  const { handleSetEmail, handleSetForgetPasswordOtpId, handleSetOtpCreateTime } = useOTPContext();

  const onFinish = (values: { email: string }) => {
    const { email } = values;
    forgetPassword.mutate(
      { email },
      {
        onSuccess: (response: any) => {
          handleSetEmail(email);
          handleSetForgetPasswordOtpId(response.data.data.otpId);
          handleSetOtpCreateTime(response.data.data.createTime);
          onChangeStage(SignInStageEnum.FORGET_PASSWORD_OTP);
        },
        onError(response) {
          const errorMsg = getServerErrorMsg(response);
          errorNotification(errorMsg);
        },
      }
    );
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Flex className="h-full w-full" justify="center" align="center" vertical gap={8}>
      <ForgetPasswordHeader />
      <Form
        form={forgetPasswordForm}
        name="forget-password"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        layout="vertical"
        className="w-full max-w-[400px]"
        validateTrigger={false}
        requiredMark={customizeRequiredMark}
      >
        <Form.Item
          label={t('email')}
          name="email"
          rules={[
            { required: true, message: t('emailRequired') },
            { type: 'email', message: t('invalidEmail') },
          ]}
          normalize={(value) => value.trim()}
        >
          <Input
            autoCapitalize="none"
            onChange={() => {
              forgetPasswordForm.validateFields(['email']);
            }}
          />
        </Form.Item>

        <Form.Item>
          <Button
            className="btn-primary mt-5"
            type="primary"
            htmlType="submit"
            block
            loading={forgetPassword.isPending}
          >
            {t('Submit')}
          </Button>
        </Form.Item>
        <Form.Item>
          <p className="cursor-pointer text-center text-sm font-medium">
            {t('backTo')}{' '}
            <span
              className="text-sm font-semibold text-primary hover:underline"
              onClick={() => onChangeStage(SignInStageEnum.SIGN_IN, {})}
            >
              {t('signin')}
            </span>
          </p>
        </Form.Item>
      </Form>
    </Flex>
  );
};

export default ForgetPassword;
